gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({ ignoreMobileResize: true });

const BODY = $("body");

const mainAnimJS = {
  toggleClassAnim: function () {
    setTimeout(() => {
      const animEl = document.querySelectorAll(".anim");
      const anims = gsap.utils.toArray(animEl);
      anims.forEach((el, i) => {
        gsap.to(el, {
          scrollTrigger: {
            trigger: el,
            start: "0 70%",
            scrub: true,
            onEnter: (el) => {
              anims[i].classList.add("show");
            },
            onLeaveBack: () => {
              anims[i].classList.remove("show");
            }
          }
        })
      })
    }, 500)
  },

  intro: () => {
    const introWrap = $(".intro_wrap");
    $("body").addClass("scrollLock");
    setTimeout(() => {
      BODY.addClass("scrollLock");
      $(".intro_wrap h2").addClass("hide");
      introWrap.addClass("hide");
    }, 500);
    setTimeout(() => {
      BODY.removeClass("scrollLock");
    }, 3000);
    setTimeout(() => {
      $(".main .sec_visual .txt").addClass("show");
    }, 1000)
  },

  mainSlide: function () {
    gsap.set(".sec_slide h2", {
      x: $(window).innerWidth(),
    })
    gsap.to(".sec_slide h2", {
      xPercent: -100,
      ease: "none",
      scrollTrigger: {
        trigger: ".sec_slide",
        pin: ".sec_slide h2",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
      }
    })
  },

  autoTxtPin: function () {
    gsap.to(".sec_student ", {
      scrollTrigger: {
        trigger: ".txt_auto_slide",
        pin: true,
        pinSpacing: true,
        scrub: true,
        start: 'top top',
        end: "+=100%"
      }
    })
  },

  conceptAnim: function() {
    gsap.to(".sec_concept .img_box",
        {
          maxWidth: "100%",
          ease: "none",
          immediateRender: false,
          scrollTrigger: {
            trigger: ".sec_concept",
            start: "top bottom",
            end: "top top",
            scrub: true,
            onUpdate: (e)=>{
              if(e.progress > 0.5){
                $(".sec_concept .inner").addClass("show");
              }else{
                $(".sec_concept .inner").removeClass("show");
              }
            }
          }
        }
    );
    gsap.to(".sec_concept .img_box img",
        {
          borderRadius: 0,
          ease: "none",
          scrollTrigger: {
            trigger: ".sec_concept",
            start: "top bottom",
            end:   "top top",
            scrub: true,
          }
        }
    );
    gsap.to(".sec_concept .dim", {
      backgroundColor: "rgba(249, 250, 245, 0)",
      ease: "none",
      immediateRender: false,
      scrollTrigger: {
        trigger: ".sec_concept",
        start: "40% bottom",
        end:   "top top",
        scrub: true,
      }
    });
    gsap.to(".sec_concept .inner",
        {
          opacity: 1,
          visibility: 'visible',
          top: '50%',
          immediateRender: false,
          scrollTrigger: {
            trigger: ".sec_concept",
            start: "40% bottom",
            end: "top top",
            scrub: true,
          }
        }
    );
  },

  mainStudentsSlideAnim: function(){
    const section = document.querySelector(".sec_student");
    const track   = section.querySelector(".dp_f");   // 실제로 가로로 긴 요소
    if (!section || !track) return;

    // 이미지/폰트 로딩 후에도 정확히 다시 계산되도록
    const getScrollLen = () => Math.max(0, track.scrollWidth - window.innerWidth);

    // 섹션 고정 전용 트리거 (애니메이션 없음)
    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      end: () => "+=" + getScrollLen(),
      scrub: true,
      pin: true,
      markers: false,               // 필요 없으면 지우세요
      invalidateOnRefresh: true
    });

    // 가로 이동 트윈 (pin은 여기서 쓰지 말 것!)
    gsap.to(track, {
      x: () => -getScrollLen(),
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: () => "+=" + getScrollLen(),
        scrub: true,
        invalidateOnRefresh: true
      }
    });
  },

  init: function () {
    $(".intro_wrap")?.length !== 0 ? this.intro() : undefined;
    $(".sec_slide")?.length !== 0 ? this.mainSlide() : undefined;
    this.toggleClassAnim();
    $(".txt_auto_slide")?.length !== 0 ? this.autoTxtPin() : undefined;
    $(".sec_concept")?.length !== 0 && this.conceptAnim();
    $(".main .sec_student")?.length !== 0 && this.mainStudentsSlideAnim();
  }
}


document.addEventListener("DOMContentLoaded", ready);

function ready() {
  mainAnimJS.init();
}